import { app } from '../../app.module'
app
  // アカウント推移表示用のディレクティブ
  .directive('accountChange', ($parse) => {
    return {
      template: require('./account-change.pug')(),
      restrict: 'E',
      controller: function ($scope, $attrs, AccountChangeService) {
        // グラフ表示の状態(デフォルト: 'graph')
        $scope.state = 'graph'
        // TikTok再生回数の1投稿あたりのフラグ
        $scope.ttPlaysPerPostFlg = true
        // 1投稿あたりのフラグ
        $scope.dataPerPostFlg = true
        // 1アカウントあたりのフラグ
        $scope.dataPerAccountFlg = true
        $scope.accountFollowersEmpty = true
        // youtubeのグラフ設定
        $scope.youtubeGraphData = {
          views: null,
          likes: null,
          dislikes: null,
          comments: null,
        }
        $scope.youtubeGraphConfig = {
          views: null,
          likes: null,
          dislikes: null,
          comments: null,
        }
        $scope.youtubePerPostFlg = {
          views: true,
          likes: true,
          dislikes: true,
          comments: true,
        }

        /**
         * showPostList 投稿一覧を表示
         * @param {string} time 期間
         * @param {string} periodType 期間タイプ
         */
        function showPostList(time: string, periodType: string) {
          AccountChangeService.Init.targetInfo = AccountChangeService.Graph.setTargetInfo(
            time,
            periodType
          )
          // グラフ表示の状態を'post'にする
          $scope.$apply(() => {
            $scope.state = 'post'
          })
        }

        /**
         * backToGraph グラフに戻るイベント
         */
        $scope.backToGraph = function () {
          AccountChangeService.Init.targetInfo = null
          // グラフ表示の状態を'graph'にする
          $scope.state = 'graph'
        }

        /**
         * changePerPostFlag 1投稿あたりのフラグを変更するイベント
         * @param {boolean} dataPerPostFlg 1投稿あたりのフラグ
         */
        $scope.changePerPostFlag = function (dataPerPostFlg: boolean) {
          $scope.dataPerPostFlg = dataPerPostFlg
          // アカウントグラフデータをセット
          AccountChangeService.Graph.setAccountGraphData(
            $scope.getOptions,
            $scope.dataPerPostFlg,
            $scope.ttPlaysPerPostFlg,
            $scope.dataPerAccountFlg,
            $scope.selectedPeriodType,
            $scope.snsType,
            $scope.dailyFlg,
            $scope.analyticsData.analytics,
            showPostList
          ).then((graphData) => {
            // 反応オブジェクト
            $scope.respondConfig = graphData.graphConfig.respondConfig
          })
        }

        /**
         * changePlaysPerPostFlg TikTok再生回数の1投稿あたりのフラグを変更するイベント
         * @param {boolean} ttPlaysPerPostFlg TikTok再生回数の1投稿あたりのフラグ
         */
        $scope.changePlaysPerPostFlg = function (flag: boolean) {
          $scope.ttPlaysPerPostFlg = flag
          // アカウントグラフデータをセット
          AccountChangeService.Graph.setAccountGraphData(
            $scope.getOptions,
            $scope.dataPerPostFlg,
            $scope.ttPlaysPerPostFlg,
            $scope.dataPerAccountFlg,
            $scope.selectedPeriodType,
            $scope.snsType,
            $scope.dailyFlg,
            $scope.analyticsData.analytics,
            showPostList
          ).then((graphData) => {
            // 反応オブジェクト
            $scope.playsConfig = graphData.graphConfig.playsConfig
          })
        }

        /**
         * dataImpressionsPerPostFlg1投稿あたりのフラグを変更するイベント
         * @param {boolean} dataImpressionsPerPostFlg1投稿あたりのフラグ
         */
        $scope.changeImpressionsPerPostFlag = function (dataImpressionsPerPostFlg: boolean) {
          $scope.dataImpressionsPerPostFlg = dataImpressionsPerPostFlg

          // アカウントグラフデータをセット
          AccountChangeService.Graph.setAccountGraphData(
            $scope.getOptions,
            $scope.dataImpressionsPerPostFlg,
            $scope.ttPlaysPerPostFlg,
            $scope.dataPerAccountFlg,
            $scope.selectedPeriodType,
            $scope.snsType,
            $scope.dailyFlg,
            $scope.analyticsData.analytics,
            showPostList
          ).then((graphData) => {
            $scope.impressionsConfig = graphData.graphConfig.impressionsConfig
          })
        }

        /**
         * changePerAccountFlag 1アカウントあたりのフラグを変更するイベント
         * @param {boolean} dataPerAccountFlg 1アカウントあたりのフラグ
         */
        $scope.changePerAccountFlag = function (dataPerAccountFlg: boolean) {
          $scope.dataPerAccountFlg = dataPerAccountFlg
          // 投稿数グラフをデータをセット
          $scope.postCountConfig.series[0].data = AccountChangeService.Graph.setDataPerPost(
            dataPerAccountFlg,
            $scope.postsObject.posts,
            $scope.postsObject.postsPerAccount
          )
        }

        /**
         * Youtubeの1投稿あたりを変更の処理
         * @param {string} chartType グラフタイプ
         */
        $scope.youtubeChangePerPostFlag = function (chartType: string) {
          if ($scope.youtubePerPostFlg[chartType] === true) {
            $scope.youtubeGraphConfig[chartType].series[0].data =
              $scope.youtubeGraphData[chartType].dataPerPost
          } else {
            $scope.youtubeGraphConfig[chartType].series[0].data =
              $scope.youtubeGraphData[chartType].data
          }
        }

        // アカウント詳細のデータを変更するイベント
        $scope.$watch(
          () => {
            return $scope.analyticsData
          },
          () => {
            if ($scope.analyticsData === undefined || $scope.analyticsData === null) {
              return
            }
            // アカウントグラフ設定
            setAccountGraphData()
          }
        )

        /**
         * setAccountGraphData アカウントグラフ設定
         */
        function setAccountGraphData() {
          if (
            $scope.analyticsData.analytics !== null &&
            $scope.analyticsData.analytics.length > 0
          ) {
            $scope.changeGraphEmpty = false
            if ($scope.snsType === 'youtube') {
              setYoutubeAccountGraphData($scope.analyticsData.analytics)
              return
            }
            // アカウント詳細をセット
            AccountChangeService.Graph.setAccountGraphData(
              $scope.getOptions,
              $scope.dataPerPostFlg,
              $scope.ttPlaysPerPostFlg,
              $scope.dataPerAccountFlg,
              $scope.selectedPeriodType,
              $scope.snsType,
              $scope.dailyFlg,
              $scope.analyticsData.analytics,
              showPostList
            ).then((graphData) => {
              // 反応オブジェクト
              $scope.engagementObject = graphData.engagementObject
              // 投稿数オブジェクト
              $scope.playsObject = graphData.playsObject
              $scope.postsObject = graphData.postsObject
              $scope.respondConfig = graphData.graphConfig.respondConfig
              $scope.respondRateConfig = graphData.graphConfig.respondRateConfig
              $scope.impressionsConfig = graphData.graphConfig.impressionsConfig
              $scope.postCountConfig = graphData.graphConfig.postCountConfig
              $scope.playsConfig = graphData.graphConfig.playsConfig

              changeLoadingStatus()
            })
          } else {
            $scope.changeGraphEmpty = true
            changeLoadingStatus()
          }
        }

        /**
         * Youtubeアカウントグラフデータをセット
         * @param {any[]} analyticData 分析データ
         */
        function setYoutubeAccountGraphData(analyticData: any[]) {
          const graphData = AccountChangeService.Graph.setYoutubeAccountGraphData(
            $scope.getOptions,
            $scope.selectedPeriodType,
            $scope.dailyFlg,
            analyticData,
            showPostList
          )

          // グラフ設定をセット
          $scope.youtubeGraphConfig.views = graphData.graphConfig.views
          $scope.youtubeGraphConfig.likes = graphData.graphConfig.likes
          $scope.youtubeGraphConfig.dislikes = graphData.graphConfig.dislikes
          $scope.youtubeGraphConfig.comments = graphData.graphConfig.comments
          $scope.postCountConfig = graphData.graphConfig.posts

          // グラフデータをセット
          $scope.youtubeGraphData.views = graphData.graphData.views
          $scope.youtubeGraphData.likes = graphData.graphData.likes
          $scope.youtubeGraphData.dislikes = graphData.graphData.dislikes
          $scope.youtubeGraphData.comments = graphData.graphData.comments
          $scope.postsObject = graphData.graphData.posts

          $scope.changePerAccountFlag($scope.dataPerAccountFlg)
          $scope.youtubeChangePerPostFlag('views')
          $scope.youtubeChangePerPostFlag('likes')
          $scope.youtubeChangePerPostFlag('dislikes')
          $scope.youtubeChangePerPostFlag('comments')

          changeLoadingStatus()
        }

        // アカウントのフォロワー数を変更するイベント
        $scope.$watch(
          () => {
            return $scope.accountFollowers
          },
          () => {
            $scope.followerGraphEmpty = true
            if ($scope.accountFollowers) {
              $scope.followerGraphEmpty = false
              // フォロワー数のグラフ設定
              AccountChangeService.Graph.setAccountFollowerGraph(
                $scope.getOptions.startEndDate,
                $scope.selectedPeriodType,
                $scope.snsType,
                $scope.dailyFlg,
                $scope.accountFollowers
              ).then((graphConfig) => {
                $scope.accountFollowerConfig = graphConfig
              })
            }
          }
        )

        /**
         * ローディングフラグを変更する
         */
        function changeLoadingStatus() {
          $parse($attrs.onChange)($scope, {
            isLoading: false,
            isPeriodChangeLoading: false,
          })
        }
      },
    }
  })
